export default __webpack_public_path__ + "static/media/manage_invitations_icon.8b75ce7c.svg";